import { RegentsExportCtrl } from './regents-export.controller';

export const RegentsExportStepComponent = {
  controller: RegentsExportCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./regents-export.html'),
};
